import { configureStore } from '@reduxjs/toolkit';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import rootReducer from './reducer';

const saveStateToStorage = (state) => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem('state', serializedState);
    sessionStorage.setItem('state', serializedState);
  } catch (error) {
    console.log('Error saving state to storage:', error);
  }
};

const loadStateFromStorage = () => {
  try {
    const serializedState = localStorage.getItem('state') || sessionStorage.getItem('state');
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (error) {
    console.log('Error loading state from storage:', error);
    return undefined;
  }
};

let middlewares;

switch (process.env.NODE_ENV) {
  case 'development':
    middlewares = composeWithDevTools(thunk);
    break;
  case 'production':
  default:
    middlewares = thunk;
}

const appReducer = (state, action) => {
  return rootReducer(state, action);
};

export default function createStore() {
  const persistedState = loadStateFromStorage();

  const store = configureStore({
    reducer: appReducer,
    middleware: [middlewares],
    preloadedState: persistedState,
  });

  store.subscribe(() => {
    saveStateToStorage(store.getState());
  });

  return store;
}
